export function numOr0(n: number) {
    return n && isNaN(n) ? 0 : n
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/NumberHelper.ts